import axios from 'axios'

export default function () {
  if (process.env.VUE_APP_MODE === 'production') {
    try {
      // todo: there is no end points for each countris
      const host = location.host.split('.')
      const countryCode = host[host.length - 1]
      const appApi = process.env[`VUE_APP_API_${countryCode.toUpperCase()}`]
      if (!appApi) {
        throw new Error('no api setting')
      }
      axios.defaults.baseURL = appApi
    } catch (e) {
      axios.defaults.baseURL = process.env['VUE_APP_API_COM']
    }
  } else {
    axios.defaults.baseURL = process.env.VUE_APP_LAMBDA_API
  }
}
